import { Button } from '@/theme/components';
import { styled } from '@/theme/index';

export const FlexContainer = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const DivContainer = styled('div')(() => ({
  width: '100%',
}));

export function ProgressBarActions({
  onUpgradePlanClick,
}: {
  onUpgradePlanClick: () => void;
}) {
  return (
    <Button
      sx={{ marginBottom: '10px' }}
      fullWidth
      variant="contained"
      color="success"
      onClick={onUpgradePlanClick}
      data-cy="upgrade_plan_cta_btn"
    >
      Upgrade plan
    </Button>
  );
}
